import "./style.sass";
import assets from "../../assets";

export const QuizHero = () => {
  return (
    <section className="quiz-hero-container">
      <section className="icon-circle-quiz">
        <img src={assets.ic_quest} alt="quiz test" />
      </section>

      <h1 className="title">Objective Test</h1>
      <p className="subtitle">
        Dynamic quiz generation with instant feedback and performance tracking
      </p>

      <section className="info-card">
        
        <h3>Why use AI objective generator?</h3>

        <div className="features-grid">
          <section className="feature">
            <section className="feature-icon">⚡</section>
            <section>
              <h4>Instant Feedback</h4>
              <p>
                Real-time analysis and detailed explanations.
              </p>
            </section>
          </section>

          <section className="feature">
            <section className="feature-icon">🎯</section>
            <section>
              <h4>Personalized Difficulty</h4>
              <p>
                Adaptive selection that aligns with your level.
              </p>
            </section>
          </section>

          <section className="feature">
            <section className="feature-icon">⏱</section>
            <section>
              <h4>Time Management</h4>
              <p>
                Practice under real exam conditions.
              </p>
            </section>
          </section>
        </div>
      </section>

      <section className="instruction-box">
        Get started by selecting your subject, chapter and number of questions
      </section>
    </section>
  );
};
